
<div class="row header gx-0 px-2 pt-2">
    <div class="col-md-10 d-flex align-items-center">
        <h2 class="py-2">{{ 'onboarding.title' | translate}}</h2>
    </div>
    @if(step.index < 5){
        <div class="col-md-2 text-end">
            <p>{{'onboarding.step' | translate}} {{step.index}} {{'onboarding.step.prop' | translate}} 4</p>
            <h4>{{ 'onboarding.'+step.id | translate }}</h4>
        </div>
    }
</div>

<hr class="d-none d-md-block">

<div class="row steps d-none d-md-flex justify-content-center gx-0 px-2 py-3 mt-md-3">
    <div class="col-md-2 col-sm-2 text-center text-nowrap"
            [ngClass]="{'disabled': step.index > 4}">
        <span class="fa-stack fa-2x">
            <i class="far fa-circle fa-stack-2x"></i>
            <i class="far fa-user fa-stack-1x"></i>
        </span>
        <p>{{ 'onboarding.aboutyou' | translate }}</p>
    </div>
    <div class="col-md-2 col-sm-2 text-center text-nowrap"
            [ngClass]="{'disabled': step.id == 'aboutyou' || step.index > 4}">
        <span class="fa-stack fa-2x">
            <i class="far fa-circle fa-stack-2x"></i>
            <i class="far fa-cog fa-stack-1x"></i>
        </span>
        <p>{{ 'onboarding.settings' | translate }}</p>
    </div>
    <div class="col-md-2 col-sm-2 text-center text-nowrap"
            [ngClass]="{'disabled': step.id == 'aboutyou' || step.id == 'settings' || step.index > 4}">
        <span class="fa-stack fa-2x">
            <i class="far fa-circle fa-stack-2x"></i>
            <i class="far fa-users fa-stack-1x"></i>
        </span>
        <p>{{ 'onboarding.team_members' | translate }}</p>
    </div>
    <div class="col-md-2 col-sm-2 text-center text-nowrap"
            [ngClass]="{'disabled': step.id == 'aboutyou' || step.id == 'settings'|| step.id == 'team_members' || step.index > 4}">
        <span class="fa-stack fa-2x">
            <i class="far fa-circle fa-stack-2x"></i>
            <i class="far fa-check fa-stack-1x"></i>
        </span>
        <p>{{ 'onboarding.ready' | translate }}</p>
    </div>
</div>
